// extracted by mini-css-extract-plugin
module.exports = {"link":"Settings-link-tvjY0 Link-link-1rgM9","summary":"Settings-summary-3KPAv"};